// Lightweight wrapper around Facebook Meta Pixel (fbq)
// to avoid errors when fbq is not loaded or running on server.

export const fbqSafe = (...args) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args);
  } else {
    // Optional: uncomment to debug events locally
    // console.debug('[fbq]', ...args);
  }
};

export const trackPageView = () => {
  fbqSafe('track', 'PageView');
};

export const trackAddToCart = (payload = {}) => {
  fbqSafe('track', 'AddToCart', payload);
};

export const trackInitiateCheckout = (payload = {}) => {
  fbqSafe('track', 'InitiateCheckout', payload);
};

export const trackPurchase = (payload = {}) => {
  fbqSafe('track', 'Purchase', payload);
};
